<template>
  <div>
    <div class="header">
			<div class="inner clearfix">
				<a href="http://www.bjrs.org.cn/m" class="logo"><img :src="`${global.remoteIp}/uploads/${webConfigs.logopic}`" /></a>
				<div class="btn">
					<span class="bar"></span>
					<span class="bar"></span>
					<span class="bar"></span>
				</div>
			</div>
			<div class="nav">
				<div class="mask"></div>
				<div class="list">
					<ul class="clearfix">
						<li><a href="http://www.bjrs.org.cn/" @click="chgNav()">首页</a></li>
						<li  v-for="(navmodel, index) in navs" :key="index" @click="chgNav(navmodel)"><router-link
              :to="navmodel.link"
              >{{ navmodel.name }}</router-link
            ></li>
					</ul>
				</div>
			</div>
		</div>
    <div class="bread" v-if="$route.path.indexOf('certResult')<0">
			<div class="inner">
				<a href="http://www.bjrs.org.cn/">首页</a><span>&gt;</span><a
					href="javascript:;">{{ breadTitle }}</a><span>&gt;</span><a href="javascript:;">{{ breadSubTitle }}</a>
			</div>
		</div>
		<div class="small-nav" v-if="$route.path.indexOf('certResult')<0&&navSubs.length">
			<div class="small-nav-header clearfix">
				<img src="/static/img/down.jpg">
				<span>{{navSubs[0]?navSubs[0].name:''}}</span>
			</div>
			<div class="small-nav-body">
				<router-link v-for="(navsub, indexex) in navSubs" :key="indexex" :to="navsub.link">{{navsub.name}}</router-link>
			</div>
		</div>
  </div>
</template>
<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  name: "head-nav",
  props: {
    webConfigs: Object,
    plates: Array,
  },
  data() {
    return {
      global,
      keyWords: "",
      contactour: "",
      aboutour: "",
      articles: [],
      navs: [],
      time: "",
      timer:{},
      navSubs:[]
    };
  },
  mounted() {
    this.timer = setInterval(this.getData, 1000);
    let navModels = [
      {
        name: "机构概况",
        type: "info",
      },
      {
        name: "通知公告",
        type: "view",
      },
      {
        name: "工作动态",
        type: "view",
      },
      {
        name: "证书查询",
        type:'hasSub',
        navSub:[
          {
            name: "专业人才技能证书",
            type:"link",
            link: "/inqCert?type=zyrc"
          },
          {
            name: "荣誉证书",
            type:"link",
            link: "/inqCert?type=ryzs"
          },
          {
            name: "客座教授",
            type:"link",
            link: "/inqCert?type=kzjs"
          }
        ]
      },
      {
        name: "课题研究",
        type:'hasSub',
        navSub: [
          {
            name: "课题立项",
            type:"view"
          },
          {
            name: "课题公示",
            type:"view"
          },
          {
            name: "课题结项",
            type:"view"
          },
          {
            name: "学术成果",
            type:"view"
          }
        ]
      },
      {
        name: "专家智库",
        type:'hasSub',
        navSub: [
          {
            name: "专家观点",
            type:"view"
          },
          {
            name: "科普知识",
            type:"view"
          }
        ]
      },
      {
        name: "合作交流",
        type:'hasSub',
        navSub: [
          {
            name: "成果展示",
            type:"view"
          },
          {
            name: "合作项目",
            type:"view"
          }
        ]
      },
      {
        name: "培训基地",
        type:"view"
      },
      {
        name: "产学研结合",
        type:"view"
      },
      {
        name: "信息查询",
        type: "local",
        link: "/infoQuery"
      },
      {
        name: "联系我们",
        type: "info",
      },
    ];
    // this.$axios.get("/api/categorys?page=1&limit=30").then((res) => {
    //   if (res.data) {
    let plates = this.plates;
    plates.forEach((plate) => {
      
      if (plate.name == "分会介绍") {
        this.aboutour = "/news/info/" + plate._id + "/000000";
      } else if (plate.name == "联系我们") {
        this.contactour = "/news/info/" + plate._id + "/000000";
      }
    });

    navModels.forEach((model) => {
      let nav;
      if (model.type == "query") {
        nav = {
          name: model.name,
          link: "/applySociety",
        };
      } else if (model.type == "home") {
        nav = {
          name: model.name,
          link: "/",
        };
      }else if (model.type == "company"){
        nav = {
          name: model.name,
          link: "/company",
          type:'link'
        };
      }else if (model.type == "export"){
        nav = {
          name: model.name,
          link: "/export",
          type:'link'
        };
      }else if (model.type == "local"){
        nav = {
          name: model.name,
          link: model.link,
        };
      }else if (model.type == "hasSub")
      {
        let subs = model.navSub;
        nav = {
          navSubs:[]
        }
        for(let k = 0; k < subs.length; k++)
        {
          if(subs[k].type =='view')
          {
            for (let i = 0; i < plates.length; i++) {
              let plate = plates[i];
              if (subs[k].type == "info" && subs[k].name == plate.name) {
                nav.navSubs.push({
                  name: subs[k].name,
                  link: "/news/info/" + plate._id + "/000000",
                });
              } else if (subs[k].type == "view" && subs[k].name == plate.name) {
                nav.navSubs.push({
                  name: subs[k].name,
                  link: "/news/views/" + plate._id,
                });
              }else{
               
              }
            }
          }else{
            nav.navSubs.push({
              name: subs[k].name,
              link: subs[k].link,
            });
            this.navSubs=nav.navSubs;
            console.log("this.navSubs==",this.navSubs)
          }
        }
        nav.name = model.name;
        nav.type ='hasSub';
        console.log(nav.navSubs)
        nav.link = nav.navSubs[0]?nav.navSubs[0].link:'';
      }
      else {
        for (let i = 0; i < plates.length; i++) {
          let plate = plates[i];
          if (model.type == "info" && model.name == plate.name) {
            nav = {
              name: model.name,
              link: "/news/info/" + plate._id + "/000000",
            };
          } else if (model.type == "view" && model.name == plate.name) {
            nav = {
              name: model.name,
              link: "/news/views/" + plate._id,
            };
          }
        }
      }
      if (nav) this.navs.push(nav);
    });
     this.$nextTick(function(){
       $(function(){
          $(".header .btn").click(function(){
          $("html").toggleClass("open")
        })
          $(".small-nav-header").click(function(){
            $(this).siblings(".small-nav-body").toggle();
          })
        });
     })
  },
  created(){
    
  },
  methods: {
    chgNav(navmodel){
      this.navSubs = navmodel?navmodel.type =='hasSub'?navmodel.navSubs:[]:[];
    },
    getData() {
      
      let week = ["日", "一", "二", "三", "四", "五", "六"];
      let date = new Date();
      let getday = date.getDay();
      this.time= `${date.getFullYear()}年${
        date.getMonth() + 1
      }月${date.getDate()}日 ${('00'+date.getHours()).slice(-2)}:${('00'+date.getMinutes()).slice(-2)}:${('00'+date.getSeconds()).slice(-2)} 星期${week[getday]}`;
    },
    search() {
      this.$router.replace("/news/views/search?keyWords=" + this.keyWords);
    },
    toTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  computed: {
    breadTitle() {
      return this.$route.path.indexOf("infoQuery") > -1 ? "信息查询" : "证书查询";
    },
    breadSubTitle() {
      return this.$route.path.indexOf("infoQuery") > -1 ? "查询结果" : "专业人才技能证书";
    },
  }
};
</script>

<style scoped>

.header{
  position: inherit;
	top: 0;
	left: 0;
	right: 0;
	z-index: 99;
	background: #fff;
  padding: 0;
	/*box-shadow: 0 0 16px rgba(128,128,128,0.3);*/
}

.header .logo{
	float: left;
}

.header .logo img{
	display: block;
	height: 44px;
}

.header .inner{
	position: relative;
	padding: 12px 42px 12px 12px;
}

.header .btn{
	position: absolute;
	right: 12px;
	top: 50%;
	-webkit-transform: translateY(-50%);
	-moz-transform: translateY(-50%);
	-ms-transform: translateY(-50%);
	-o-transform: translateY(-50%);
	transform: translateY(-50%);
	height: 21px;
}

.header .btn .bar{
	position: relative;
	display: block;
	width: 28px; 
	height: 3px;
	background: #1b57af;
	margin-top: 6px;
	-webkit-transition: all .4s ease;
	-moz-transition: all .4s ease;
	-ms-transition: all .4s ease;
	-o-transition: all .4s ease;
	transition: all .4s ease;
}

.header .btn .bar:first-child{
	margin-top: 0;
}

.header .nav{
	position: fixed;
	top: 68px;
	left: 0;
	right: 0;
	bottom: 0;
	opacity: 0;
	visibility: hidden;
	-webkit-transition: all .4s ease;
	-moz-transition: all .4s ease;
	-ms-transition: all .4s ease;
	-o-transition: all .4s ease;
	transition: all .4s ease;
}

.header .nav .list{
	position: relative;
	top: -24px;
	background: #fff;
	padding: 12px 12px 6px;
	overflow: hidden;
	-webkit-transition: all .4s ease;
	-moz-transition: all .4s ease;
	-ms-transition: all .4s ease;
	-o-transition: all .4s ease;
	transition: all .4s ease;
}

.header .nav .list ul{
	position: relative;
	margin-left: -12px;
}

.header .nav .list li{
	float: left;
	width: 50%;
	margin-bottom: 12px;
}

.header .nav .list li a{
	display: block;
	height: 48px;
	line-height: 48px;
	margin-left: 12px;
	font-size: 16px;
	color: #fff;
	-webkit-border-radius: 5px;
	-moz-border-radius: 5px;
	border-radius: 5px;
	background: #1b57af;
	text-align: center;
	padding: 0 16px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.header .nav .mask{
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0,0,0,0.5);
}

.open{
	overflow: hidden;
}

.open .nav{
	opacity: 1;
	visibility: visible;
}

.open .nav .list{
	top: 0;
}

.open .inner .btn .bar:nth-child(1){
	top: 10px;
	-webkit-transform: rotate(135deg);
	-moz-transform: rotate(135deg);
	-ms-transform: rotate(135deg);
	-o-transform: rotate(135deg);
	transform: rotate(135deg);
}

.open .inner .btn .bar:nth-child(2){
	opacity: 0;
	top: 5px;
	-webkit-transform: rotate(135deg);
	-moz-transform: rotate(135deg);
	-ms-transform: rotate(135deg);
	-o-transform: rotate(135deg);
	transform: rotate(135deg);
}

.open .inner .btn .bar:nth-child(3){
	top: -8px;
	-webkit-transform: rotate(225deg);
	-moz-transform: rotate(225deg);
	-ms-transform: rotate(225deg);
	-o-transform: rotate(225deg);
	transform: rotate(225deg);
}

.footer{
	padding: 10px 12px 12px;
	font-size: 14px;
	color: #000000;
	line-height: 1.4;
	border-top: 2px solid #1b57af;
	margin-top: 20px;
	    text-align: center;
}

.footer p{
	margin-top: 6px;
}

.bread{
	margin: 0 12px 12px;
	padding: 12px 0;
	border-bottom: 2px solid #1b57af;
}

.bread .inner{
	font-size: 15px;
	color: #1b57af;
	border-left: 3px solid #1b57af;
	padding-left: 8px;
}

.bread a,
.bread span{
	display: inline-block;
	vertical-align: top;
	color: #1b57af;
	line-height: 1.1;
}

.bread span{
	margin: 0 4px;
}

.small-nav{
	border: 2px solid #1b57af;
	margin: 0 12px;
	-webkit-border-radius: 5px;
	-moz-border-radius: 5px;
	border-radius: 5px;
}

.small-nav-header{
	position: relative;
	height: 48px;
	line-height: 48px;
	padding: 0 12px;
	font-size: 18px;
	color: #1b57af;
}

.small-nav-header img{
	float: right;
	width: 16px;
	height: 16px;
	margin-top: 16px;
}

.small-nav-body{
	display: none;
}

.small-nav-body a{
	display: block;
	height: 40px;
	line-height: 40px;
	padding: 0 12px;
	font-size: 16px;
	border-top: 1px solid #f3f3f3;
}

</style>
